import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import StarRating from "components/StarRating";
import AppTag from "components/ui/AppTag";
import AverageFeedbackRating from "./AverageFeedbackRating";
import { getStarRatingClasses } from "utils/Utils";
const UserFeedbacksTable = ({
  feedbacks,
  avgOrderRating,
  feedbackRatingCount,
  totalCount,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="mt-2 flex flex-col-reverse flex-wrap gap-5 md:flex-row md:gap-6">
        <div className="min-w-0 flex-1 space-y-4">
          {feedbacks?.map((feedback, index) => (
            <article
              className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition-shadow duration-200 hover:shadow-md md:p-6"
              key={feedback?._id || index}
            >
              <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                <div className="min-w-0 flex-1">
                  <p
                    className="text-sm font-semibold text-primary"
                    dir="ltr"
                  >
                    {feedback?.customerInfo?.phoneNumber}
                  </p>
                  <p className="mt-1 text-base font-medium text-gray-900">
                    {t("Order #")} {feedback?.orderInfo?.orderNumber}
                  </p>
                </div>
                {feedback?.serviceType ? (
                  <div className="shrink-0">
                    <AppTag variant="neutral" size="sm">
                      {t(feedback?.serviceType)}
                    </AppTag>
                  </div>
                ) : null}
              </div>

              <div className="mt-4 flex flex-wrap items-center gap-3 border-t border-gray-100 pt-4">
                <StarRating
                  className={`star ${getStarRatingClasses(
                    feedback?.orderRating
                  )}`}
                  totalStars={5}
                  rating={feedback?.orderRating}
                  handleStarClick={() => {}}
                />
                <span className="text-sm text-gray-500">
                  {moment(feedback?.createdAt).format("DD MMM YYYY")}
                </span>
              </div>

              {feedback?.comments?.trim() ? (
                <div className="mt-4 rounded-xl bg-gray-50/90 px-4 py-3 text-sm leading-relaxed text-gray-700">
                  {feedback.comments}
                </div>
              ) : null}
            </article>
          ))}
        </div>
        <div className="w-full shrink-0 md:w-auto md:max-w-sm">
          <AverageFeedbackRating
            averageRating={avgOrderRating}
            feedbackRatingCount={feedbackRatingCount}
            totalCount={totalCount}
          />
        </div>
      </div>
    </>
  );
};

export default UserFeedbacksTable;
